import { MutableRefObject, Dispatch } from 'react';

interface Props {
  indexRef: MutableRefObject<number>;
  key: string;
  length: number;
  lowerBound?: boolean;
  maxCols: number;
  outOfBounds?: (key: string) => void;
  setIndex?: Dispatch<React.SetStateAction<number>>;
  onChange?: (index: number, increment: number) => void;
}

function mosaicKeyboardHandler({
  indexRef,
  key,
  length,
  lowerBound = false,
  maxCols,
  onChange,
  outOfBounds,
  setIndex,
}: Props) {
  let newIndex = indexRef.current;
  switch (key) {
    case 'DOWN':
      if (maxCols && maxCols < length) {
        if (newIndex + maxCols >= length) {
          if (lowerBound && outOfBounds) {
            outOfBounds('DOWN');
          } else {
            newIndex = length - 1;
          }
        } else {
          newIndex += maxCols;
        }
      }
      break;
    case 'UP':
      if (maxCols) {
        newIndex -= maxCols;
        if (newIndex < 0) {
          newIndex = indexRef.current;
          outOfBounds && outOfBounds('UP');
        }
      }
      break;
    case 'LEFT':
      if (maxCols && newIndex % maxCols !== 0) {
        newIndex -= 1;
      } else {
        outOfBounds && outOfBounds('LEFT');
      }
      break;
    case 'RIGHT':
      if (newIndex < length - 1 && newIndex % maxCols !== maxCols - 1) {
        newIndex += 1;
      }
      break;
  }
  if (newIndex !== indexRef.current && onChange) {
    onChange(newIndex, Math.floor(newIndex / maxCols));
  }
  indexRef.current = newIndex;
  setIndex && setIndex(newIndex);
}

export default mosaicKeyboardHandler;
